import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { environment } from 'src/environments/environment';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { ApiResponse } from 'src/app/core/models/api-response';
import { IdName } from 'src/app/shared/models/id-name';
import {
  IDeliveryAddressRequest,
  IDeliveryAddressResponse,
} from '../models/delivery-addresses/delivery-address.model';

@Injectable({
  providedIn: 'root',
})
export class DeliveryAddressApiService {
  headers = { 'content-type': 'application/json' };

  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/deliveryAddress`;
  }

  constructor(private http: HttpClient) {}

  getPagedDeliveryAddresses(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IDeliveryAddressResponse[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IDeliveryAddressResponse[]>>(this.url, { params });
  }

  getDeliveryAddressList(departmentId?: string): Observable<IdName[]> {
    let params = new HttpParams();
    if (departmentId) {
      params = params.set('DepartmentId', departmentId);
    }
    return this.http.get<IdName[]>(`${this.url}/List`, { params });
  }

  getDeliveryAddressById(id: string): Observable<IDeliveryAddressResponse> {
    return this.http.get<IDeliveryAddressResponse>(`${this.url}/${id}`);
  }

  createDeliveryAddress(
    deliveryAddress: IDeliveryAddressRequest
  ): Observable<IDeliveryAddressResponse> {
    return this.http.post<IDeliveryAddressResponse>(this.url, deliveryAddress, {
      headers: this.headers,
    });
  }

  updateDeliveryAddress(
    deliveryAddress: IDeliveryAddressRequest
  ): Observable<IDeliveryAddressResponse> {
    return this.http.put<IDeliveryAddressResponse>(
      `${this.url}/${deliveryAddress.id}`,
      deliveryAddress,
      {
        headers: this.headers,
      }
    );
  }

  deleteDeliveryAddress(deliveryAddressId: string): Observable<any> {
    return this.http.delete(`${this.url}/${deliveryAddressId}`);
  }
}
